
<template>
  <div class="newsitem">
    <div class="box" @click="goDetail(row.id)">
      <div
        class="jumbimg"
        :style="{ backgroundImage: 'url(' + row.imageUrl + ')' }"
      ></div>
      <div class="info">
        <div class="time">{{ fmtTime }}</div>
        <div class="title">{{ row.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    fmtTime() {
      var t = this.row.createTime;
      if (t) {
        return dayjs(t).format("YYYY年M月D日");
      }
      return ""
    },
  },
  methods: {
    goDetail(id) {
      if (id) {
        this.$router.push({
          path: `/news/detail/${id}`
        })
      }
    }
  }
};
</script>
<style lang="less">
.newsitem {
  background: #ffffff;
  // box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  margin-bottom: 44px;
  .jumbimg {
    height: 198px;
    background: #e6e6e6;
    display: flex;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .info {
    box-sizing: border-box;
    margin-top: 20px;
    .time {
      margin-bottom: 5px;
      color: #2284f6;
      font-size: 14px;
    }
    .title {
      font-size: 14px;
      line-height: 20px;
      color: #000000;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>